// extracted by mini-css-extract-plugin
export default {"container":"PageEditor_container__a-3q2","footer":"PageEditor_footer__D239u"};